const StatsPage = () => {
    return (
        <div className='container flex flex-col items-center justify-center py-7'>
            <div className='h-[800px] w-full'>
                <iframe
                    src='https://lookerstudio.google.com/embed/reporting/e9d083ac-93e0-402d-bd68-e2885718194a/page/p_ht30xh19id'
                    frameBorder='0'
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                    }}
                    allowFullScreen
                />
            </div>
        </div>
    )
}

export default StatsPage
